/**
 * @packageDocumentation
 * Houses shared visual constants, filters, and helpers reused across multiple game components.
 */
/**
 * @module filters
 */
import * as PIXI from "pixi.js";  
import { ShockwaveFilter } from '@pixi/filter-shockwave';
import { ShowCent } from "./server";
import { AdjustmentFilter } from '@pixi/filter-adjustment';
/**
 * Filter that increases brightness by 20%
 */
export let brightnessFilter = new PIXI.ColorMatrixFilter()
brightnessFilter.brightness(1.2,true);
brightnessFilter.resolution = 2;

export let brightnessFilter2 = new PIXI.ColorMatrixFilter()
// brightnessFilter2.brightness(1.5,true);
brightnessFilter2.resolution = 2;


 
export let dullFilter = new PIXI.ColorMatrixFilter()
dullFilter.brightness(0.8,true);
dullFilter.resolution = 2;

export let dullFilter2 = new PIXI.ColorMatrixFilter()
dullFilter2.brightness(0.5,true);
dullFilter2.resolution = 2;
/**
 * Filter that decreases brightness by 20%
 */
export let DarknessFilter = new PIXI.ColorMatrixFilter()
DarknessFilter.brightness(0.8,false);
DarknessFilter.resolution = 2;
/**
 * Filter that decreases brightness by 20%
 */
export let disabledfilter = new PIXI.ColorMatrixFilter()
disabledfilter.desaturate();


/**
 * Shockwave visual effect filter
 * @param center - Center point coordinates [x, y]
 * @param options - Configuration options for the shockwave
 * @property amplitude - Wave amplitude
 * @property wavelength - Wave length
 * @property brightness - Wave brightness
 * @property radius - Maximum radius (-1 for unlimited)
 */
export const shockwave = new ShockwaveFilter([5000, 80000], {
    amplitude: 30,
    wavelength: 160,
    brightness: 2.0,
    radius: -1, // -1 = no limit
    // time: 0,
});
shockwave.time = 0;

/**
 * Formats text to show cents for values less than 1
 * @param Text - PIXI.Text object to modify
 * @param value - Numeric value to format
 */
export function applyCent(Text:PIXI.Text,value:number){
    if(ShowCent){
        if(value<1&&value>0){
            Text.text = (value*100)+"¢"; 
            if(Text.text.length>4){
                Text.text = (value*100).toFixed(2)+"¢";  
            }
        } 
    } 
}

/**
 * Main font used in the application
 */
export const font_main = 'FranklinGothic-Demi'
  
/**
 * Secondary font
 */
export const font_secondary = "calibri"
export const font_third = "Bangers-Regular"

export function HandleOrientation(PortraitAdjustFun:()=>void,landScapeAdjustFun:()=>void){
    
    if (window.matchMedia("(orientation:portrait)").matches) {
        PortraitAdjustFun();
    } else { 
        landScapeAdjustFun();
    }    
    window.addEventListener("resize", ()=>{
            if (window.matchMedia("(orientation:portrait)").matches) {
              PortraitAdjustFun();
            } else { 
              landScapeAdjustFun();
            }
    });
} 